// to turn off ad refreshing on the homepage.
// disabled below 2022-09-14 per request from JdC
// if(window.location.pathname === '/') refreshVisibleAdsAfter = 0;

jQuery(function($) {
	smiBlock.get(); // this triggers the contentloader.js script to build the page

	smiDfp.addBreakpoint('adhesion', 0, 480, false);
	smiDfp.addBreakpoint('phone', 0, 767, false);
	smiDfp.addBreakpoint('tablet', 768, 1023, false);
	smiDfp.addBreakpoint('desktop', 1024, 0, true);

	smiDfp.addGlobalTargeting("loggedin", cphGlobal.getCookieByName("IsSubscriber") === 'True' ? 'true' : 'false');

	var ad, wrap, shim;

	ad = smiDfp.buildAd('tablet,desktop');
	ad.addSize(1, 1);
	$('#one-by-one-ad').html(ad.render());


	wrap = smiDfp.buildAdWrapper();

	ad = smiDfp.buildAd('desktop');
	ad.addTargeting('position', 'ATF');
	ad.addTargeting('loc', '1');
	ad.addTargeting('type', 'sectionfront');
	ad.addSize(728, 90);
	ad.addSize(970, 90);
	//ad.addSize(970, 250); // removed 2023-07-07 at Tom's request
	ad.setNoReload();
	ad.wrapWith(wrap);

	ad = smiDfp.buildAd('tablet');
	ad.addTargeting('position', 'ATF');
	ad.addTargeting('loc', '1');
	ad.addTargeting('type', 'sectionfront');
	ad.addSize(728, 90);
	ad.setNoReload();
	ad.wrapWith(wrap);

	$('#leaderboard-atf').html(wrap);


	wrap = smiDfp.buildAdWrapper();

	ad = smiDfp.buildAd('desktop');
	ad.addTargeting('position', 'BTF');
	ad.addTargeting('loc', '2');
	ad.addTargeting('type', 'sectionfront');
	ad.addSize(728, 90);
	ad.addSize(970, 90);
	ad.setDelay(5000);
	ad.wrapWith(wrap);

	ad = smiDfp.buildAd('tablet');
	ad.addTargeting('position', 'BTF');
	ad.addTargeting('loc', '2');
	ad.addTargeting('type', 'sectionfront');
	ad.addSize(728, 90);
	ad.setDelay(5000);
	ad.wrapWith(wrap);

	ad = smiDfp.buildAd('phone');
	ad.addTargeting('position', 'BTF');
	ad.addTargeting('loc', '2');
	ad.addTargeting('type', 'sectionfront');
	ad.addSize(300, 250);
	ad.setDelay(5000);
	ad.wrapWith(wrap);

	$('#leaderboard-btf').html(wrap);

	wrap = smiDfp.buildAdWrapper('pw-adhesion-wrap');
	ad = smiDfp.buildAd('adhesion');
	ad.addSize(320, 50);
	ad.addSize(320, 100);
	ad.addTargeting('position', 'ATF');
	//ad.setNoReload(); // turned off 9/14/2022 per request from JdC
	ad.wrapWith(wrap);

	$("#adhesion-ad").html(wrap);


	shim = smiDfp.buildAdShim("adhesion", "50px");
	$("#adhesion-shim").html(shim);


	$(".dynamic-leaderboard-ad").each(function() {
		wrap = smiDfp.buildAdWrapper("widget-centered", "text-align: center;");

		ad = smiDfp.buildAd('tablet,desktop');
		ad.addSize(728, 90);
		ad.setDelay(2000);
		ad.wrapWith(wrap);

		$(this).html(wrap);
	});

	smiDfp.loadAds();



	// article.js has this same section, but need this code for homepage on SCG. Will test & integrate at later date.
	var sAdDelay = 500;
	$('.sidebar-cube-ad, .sidebar-half-ad, .sidebar-house-ad').each(function(i) {
		var cube = $(this),
			dataClass = cube.data('class'),
			dataTargeting = cube.data('targeting'),
			adClass = null,
			cubeLoc = 0,
			halfLoc = 0,
			houseLoc = 0,
			adLoc, adSize;

		sAdDelay = sAdDelay + 100;

		if(cube.hasClass('sidebar-half-ad')) {
			adSize = [300, 600];
			halfLoc = halfLoc + 1;
			adLoc = halfLoc;
		} else if(cube.hasClass('sidebar-house-ad')) {
			adSize = [300, 100];
			houseLoc = houseLoc + 1;
			adLoc = houseLoc;
		} else {
			adSize = [300, 250];
			cubeLoc = cubeLoc + 1;
			adLoc = cubeLoc;
		}

		if(dataClass && dataClass !== 'undefined') {
			adClass = dataClass;
		}

		ad = smiDfp.buildAd('desktop', adClass);
		ad.addSize(adSize[0], adSize[1]);
		ad.addTargeting('type', 'article');
		ad.addTargeting('loc', adLoc);
		ad.setDelay(sAdDelay);
		if(dataTargeting && dataTargeting !== 'undefined') {
			$.each(dataTargeting, function(key, value) {
				ad.addTargeting(key, value);
			});
		}

		$(this).html(ad.render());
	});
});
jQuery(function($) {
    try {
        var lsTest = 'lsTest';
        sessionStorage.setItem(lsTest, lsTest);
        sessionStorage.removeItem(lsTest);
    } catch(e) {
        return;
    }

    if(window.pageType === 'section') {
        var setClickOffset = function(parent) {
            var id = parent.attr('id');

            if(!id) return;

            var clickOffsets = getClickOffsets();
            clickOffsets[id] = parent[0].getBoundingClientRect().top;

            sessionStorage.setItem('lastClickOffset', id);
            sessionStorage.setItem('clickOffsets', JSON.stringify(clickOffsets));
        };

        var getClickOffsets = function() {
            return JSON.parse(sessionStorage.getItem('clickOffsets') || '{}');
        };

        var getClickOffset = function(id) {
            return getClickOffsets()[id] || null;
        };

        var getLastClickOffset = function() {
            return sessionStorage.getItem('lastClickOffset') || '';
        };

        var killLastClickOffset = function() {
            sessionStorage.removeItem('lastClickOffset');
        };

        $('.tpl2022__block, .content-block').on('click', 'a', function(e) {
            var clicked = $(this),
                parent = clicked.closest('[id]');
            setClickOffset(parent);
        });

        $(document).on('tpl:blockLoaded', function(e, block) {
            block = $(block);
            if(!block.length) return;

            var parentId = block.attr('id');
            if(!parentId) return;

            if(parentId && parentId === getLastClickOffset()) {
                killLastClickOffset();
                $('html, body').scrollTop(block.offset().top - getClickOffset(parentId));
            }
        });
    }
});
// FORCE CERTAIN ADS TO HIDE AND IMAGES TO SHOW USING QUERY STRING PARAMETERS
// ONLY NEEDED ON HOMEPAGE AND USED FOR SCREENSHOTLAYER API
jQuery(function($) {
    if(cphGlobal.getQueryStringValueByKey("noads") === "1") {
        $("#one-by-one-ad, #leaderboard-atf, #leaderboard-btf, #top-notifications, #bottom-sticky").remove();
        $("head").append('<style>.bcpNotificationBar, .cph-ccpa_banner { display: none !important; }</style>');
    }

    if(cphGlobal.getQueryStringValueByKey("nolazy") === "1") {
        setTimeout(function() {
            smiBlock.adaptImages('body', true);
        }, 8000);
        $(document).on('tpl:jsonLoaded', function() {
            smiBlock.adaptImages('body', true);
        });
        $(".lazyload[data-src]").not(".loading").each(function() {
            var image = $(this),
                src = image.data("src");

            image.attr("data-src", "").addClass("loading");
            image.on("load", function() {
                image.removeClass("lazyload loading");
            });
            image.attr("src", src);
        });
    }
});